import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './layouts/Layout'
import ProtectedRoute from './components/auth/ProtectedRoute'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import SignUpPage from './pages/SignUpPage'
import StorageTestPage from './pages/StorageTestPage'
import VideosPage from './pages/VideosPage'
import NovoPage from './pages/NovoPage'
import AreaPage from './pages/AreaPage'
import CreateProcessPage from './pages/CreateProcessPage'
import ProcessPage from './pages/ProcessPage'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Rotas públicas */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            
            {/* Rotas protegidas */}
            <Route path="/" element={<Layout />}>
              <Route index element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              } />
              <Route path="storage-test" element={
                <ProtectedRoute>
                  <StorageTestPage />
                </ProtectedRoute>
              } />
              <Route path="videos" element={
                <ProtectedRoute>
                  <VideosPage />
                </ProtectedRoute>
              } />
              <Route path="novo" element={
                <ProtectedRoute>
                  <NovoPage />
                </ProtectedRoute>
              } />
              <Route path="areas/:id" element={
                <ProtectedRoute requireCompany={true}>
                  <AreaPage />
                </ProtectedRoute>
              } />
              <Route path="areas/:areaId/processo/novo" element={
                <ProtectedRoute requireCompany={true} allowedRoles={['owner', 'admin', 'collaborator']}>
                  <CreateProcessPage />
                </ProtectedRoute>
              } />
              <Route path="areas/:areaId/processo/:processId" element={
                <ProtectedRoute requireCompany={true}>
                  <ProcessPage />
                </ProtectedRoute>
              } />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
